import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { faturaColumns } from './columns/_columns'
import { FaturaList } from '../core/_models'
import { FaturaExpandedRow } from './columns/FaturaExpandedRow'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => faturaColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma fatura encontrada'
      description='Revise a instituição, o período ou a situação.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma fatura gerada'
      description={`Use “${t('gerar_fatura.label')}” para faturar os atendimentos de um período.`}
    />
  )

  return (
    <CustomTable<FaturaList>
      id='kt_table_faturas'
      ariaLabel={t('fatura.plural')}
      itemLabel={{ singular: 'fatura', plural: 'faturas' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      enableExpand
      onExpandFetch={async (row) => row.original}
      getExpandLabel={(row) => row.descricao || `fatura ${row.id}`}
      renderExpand={(data: FaturaList, loading) => (
        <FaturaExpandedRow data={data} isLoading={loading} />
      )}
    />
  )
}
